import { BudgetVersionType } from './../enum/budgetVersionType.enum';
export class BudgetDetailSearch {
    constructor(
        public budgetId?: string,
        public costCenterId?: string,
        public schoolDepartmentId?: string,
        public schoolProjectId?: string,
        public version?: BudgetVersionType
    ) {
        this.budgetId = budgetId ? budgetId : null;
        this.costCenterId = costCenterId ? costCenterId : null;
        this.schoolDepartmentId = schoolDepartmentId ? schoolDepartmentId : null;
        this.schoolProjectId = schoolProjectId ? schoolProjectId : null;
        this.version = version ? version : null;
    }
}
export class MonthBudget {
    constructor(
        public amount?: number,
        public month?: number,
        public errorMessage?: string
    ) {
        this.amount = amount ? amount : 0;
        this.month = month ? month : 0;
        this.errorMessage = errorMessage ? errorMessage : '';
    }
}
